import { DURATION_PERIODS } from './CommonConstants';

export const DATE_FORMAT = {
  defaultDateFormat1: 'YYYY-MM-DD',
  defaultDateFormat2: 'D MMM YYYY',
};

export const DATE_OPERATION_AMOUNT = {
  AMOUNT_NULL: null,
  ONE_AMOUNT: 1,
};

export const DATE_OPERATION_TYPES = {
  NULL: null,
  ADD: 'add',
  ADDITION: 'addition',
  SUB: 'sub',
  SUBTRACT: 'subtract',
};

export const DATE_OPERATION_UNITS = {
  OPERATION_NULL: null,
  DAYS_UNITS: DURATION_PERIODS.DAYS.toLowerCase(),
  YEARS_UNITS: 'year',
};

export const DATE_COMPARABLES = {
  IS_AFTER: 'isAfter',
  IS_BEFORE: 'isBefore',
  IS_SAME_OR_AFTER: 'isSameOrAfter',
  IS_SAME_OR_BEFORE: 'isSameOrBefore',
};

export const TIME_TYPE_EXPRESSIONS = {
  HOURS: 'HOURS',
  MINUTES: 'MINUTES',
  SECONDS: 'SECONDS',
};

export const TIME_VALUE_EXPRESSIONS = {
  [`${TIME_TYPE_EXPRESSIONS.HOURS}_ISNULL`]: null,
  [`${TIME_TYPE_EXPRESSIONS.HOURS}_23`]: '23',
  [`${TIME_TYPE_EXPRESSIONS.MINUTES}_ISNULL`]: null,
  [`${TIME_TYPE_EXPRESSIONS.MINUTES}_59`]: '59',
  [`${TIME_TYPE_EXPRESSIONS.SECONDS}_ISNULL`]: null,
  [`${TIME_TYPE_EXPRESSIONS.SECONDS}_59`]: '59',
  [`${TIME_TYPE_EXPRESSIONS.SECONDS}_01`]: '01',
};

export const CALENDAR_FIELD_VALUES = {
  START_DATE: 'startDate',
  DUE_DATE: 'dueDate',
};
